import { useState, useCallback } from 'react';

const useUpdate = (apiService, method = 'patch') => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const update = useCallback(
    async (id, data) => {
      setLoading(true);
      setError(null);

      try {
        let response;
        switch (method) {
          case 'update':
            response = await apiService.update(id, data);
            break;
          case 'patchForm':
            response = await apiService.patchForm(id, data);
            break;
          case 'patch':
          default:
            response = await apiService.patch(id, data);
            break;
        }
        return response;
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    },
    [apiService, method],
  );

  return { update, loading, error };
};

export default useUpdate;
